var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiveChatValidationPendingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_160752",
    "data-name": "Group 160752",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 234,
    height: 174.381,
    viewBox: "0 0 234 174.381",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2088",
    "data-name": "Rectangle 2088",
    width: 234,
    height: 174.381,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2076",
    "data-name": "Rectangle 2076",
    width: 59.614,
    height: 93.2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2078",
    "data-name": "Rectangle 2078",
    width: 4.358,
    height: 5.083,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2079",
    "data-name": "Rectangle 2079",
    width: 5.499,
    height: 23.534,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2080",
    "data-name": "Rectangle 2080",
    width: 6.71,
    height: 9.248,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2081",
    "data-name": "Rectangle 2081",
    width: 3.535,
    height: 4.142,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2082",
    "data-name": "Rectangle 2082",
    width: 3.215,
    height: 8.814,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2083",
    "data-name": "Rectangle 2083",
    width: 8.912,
    height: 4.824,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2084",
    "data-name": "Rectangle 2084",
    width: 2.888,
    height: 3.547,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2086",
    "data-name": "Rectangle 2086",
    width: 24.069,
    height: 24.069,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160751",
    "data-name": "Group 160751",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2052",
    "data-name": "Rectangle 2052",
    width: 234,
    height: 0.117,
    transform: "translate(0 153.245)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2053",
    "data-name": "Rectangle 2053",
    width: 15.501,
    height: 0.117,
    transform: "translate(195.053 160.778)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2054",
    "data-name": "Rectangle 2054",
    width: 4.068,
    height: 0.117,
    transform: "translate(150.943 162.047)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2055",
    "data-name": "Rectangle 2055",
    width: 8.982,
    height: 0.117,
    transform: "translate(185.602 156.432)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2056",
    "data-name": "Rectangle 2056",
    width: 20.214,
    height: 0.117,
    transform: "translate(24.551 157.218)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2057",
    "data-name": "Rectangle 2057",
    width: 2.964,
    height: 0.117,
    transform: "translate(48.932 157.218)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2058",
    "data-name": "Rectangle 2058",
    width: 43.84,
    height: 0.117,
    transform: "translate(61.528 159.194)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160715",
    "data-name": "Group 160715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160714",
    "data-name": "Group 160714",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M131.249,132.372H40.878a2.674,2.674,0,0,1-2.671-2.671V2.671A2.675,2.675,0,0,1,40.878,0h90.37a2.675,2.675,0,0,1,2.671,2.671V129.7a2.674,2.674,0,0,1-2.671,2.671M40.878.117a2.557,2.557,0,0,0-2.554,2.554V129.7a2.557,2.557,0,0,0,2.554,2.554h90.37A2.557,2.557,0,0,0,133.8,129.7V2.671A2.557,2.557,0,0,0,131.249.117Z",
    transform: "translate(-20.326)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M347.546,132.372h-90.37a2.674,2.674,0,0,1-2.671-2.671V2.671A2.674,2.674,0,0,1,257.176,0h90.37a2.675,2.675,0,0,1,2.671,2.671V129.7a2.674,2.674,0,0,1-2.671,2.671M257.176.117a2.557,2.557,0,0,0-2.554,2.554V129.7a2.557,2.557,0,0,0,2.554,2.554h90.37A2.557,2.557,0,0,0,350.1,129.7V2.671A2.557,2.557,0,0,0,347.546.117Z",
    transform: "translate(-135.397)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2059",
    "data-name": "Rectangle 2059",
    width: 63.507,
    height: 134.217,
    transform: "translate(31.261 19.028)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2060",
    "data-name": "Rectangle 2060",
    width: 63.507,
    height: 134.217,
    transform: "translate(29.85 19.028)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2061",
    "data-name": "Rectangle 2061",
    width: 58.441,
    height: 128.525,
    transform: "translate(32.383 21.873)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M129.475,175.264l-14.8-128.525H97.954l14.8,128.525Z",
    transform: "translate(-52.111 -24.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2062",
    "data-name": "Rectangle 2062",
    width: 1.067,
    height: 128.525,
    transform: "translate(32.383 21.873)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2063",
    "data-name": "Rectangle 2063",
    width: 61.411,
    height: 3.82,
    transform: "translate(30.897 33.006)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2064",
    "data-name": "Rectangle 2064",
    width: 25.641,
    height: 77.875,
    transform: "translate(102.697 75.369)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2065",
    "data-name": "Rectangle 2065",
    width: 22.826,
    height: 22.826,
    transform: "translate(104.104 77.646)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2066",
    "data-name": "Rectangle 2066",
    width: 22.826,
    height: 22.826,
    transform: "translate(104.104 102.521)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2067",
    "data-name": "Rectangle 2067",
    width: 22.826,
    height: 22.826,
    transform: "translate(104.104 127.396)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M246.141,165.264h-10.1a2.367,2.367,0,0,0,2.367,2.367h5.371a2.367,2.367,0,0,0,2.367-2.367",
    transform: "translate(-125.571 -87.92)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M246.141,218.416h-10.1a2.367,2.367,0,0,0,2.367,2.367h5.371a2.367,2.367,0,0,0,2.367-2.367",
    transform: "translate(-125.571 -116.197)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M246.141,271.568h-10.1a2.367,2.367,0,0,0,2.367,2.367h5.371a2.367,2.367,0,0,0,2.367-2.367",
    transform: "translate(-125.571 -144.474)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2068",
    "data-name": "Rectangle 2068",
    width: 12.807,
    height: 77.875,
    transform: "translate(128.338 75.369)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2069",
    "data-name": "Rectangle 2069",
    width: 7.109,
    height: 58.629,
    transform: "translate(196.788 92.702)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2070",
    "data-name": "Rectangle 2070",
    width: 68.262,
    height: 1.914,
    transform: "translate(134.651 151.331)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2071",
    "data-name": "Rectangle 2071",
    width: 63.123,
    height: 58.629,
    transform: "translate(133.665 92.702)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M304.245,255.741h38.406a6.837,6.837,0,0,0,0-13.675H304.245a6.837,6.837,0,1,0,0,13.675m38.406-13.215a6.378,6.378,0,1,1,0,12.756H304.245a6.378,6.378,0,1,1,0-12.756Z",
    transform: "translate(-158.221 -128.779)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M304.245,292.087h38.406a6.837,6.837,0,0,0,0-13.674H304.245a6.837,6.837,0,1,0,0,13.674m38.406-13.215a6.378,6.378,0,1,1,0,12.756H304.245a6.378,6.378,0,1,1,0-12.756Z",
    transform: "translate(-158.221 -148.116)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M339.044,250.283h11.59a1.426,1.426,0,0,0,0-2.853h-11.59a1.426,1.426,0,0,0,0,2.853",
    transform: "translate(-179.613 -131.633)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M304.245,219.4h38.406a6.837,6.837,0,0,0,0-13.674H304.245a6.837,6.837,0,1,0,0,13.674m38.406-13.215a6.378,6.378,0,1,1,0,12.756H304.245a6.378,6.378,0,1,1,0-12.756Z",
    transform: "translate(-158.221 -109.444)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M339.044,213.936h11.59a1.426,1.426,0,0,0,0-2.853h-11.59a1.426,1.426,0,0,0,0,2.853",
    transform: "translate(-179.613 -112.296)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M339.044,286.629h11.59a1.426,1.426,0,1,0,0-2.853h-11.59a1.426,1.426,0,1,0,0,2.853",
    transform: "translate(-179.613 -150.969)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2072",
    "data-name": "Rectangle 2072",
    width: 64.421,
    height: 2.98,
    transform: "translate(132.367 89.722)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2073",
    "data-name": "Rectangle 2073",
    width: 8.503,
    height: 2.98,
    transform: "translate(196.788 89.722)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M321.526,81.757c1.435.72,5.329-.053,4.031,2.581A22.182,22.182,0,0,1,322.9,88.2c-1.45,1.789-1.176,3.728.536,4.432a2.108,2.108,0,0,1,.947.658c.789,1.13-1.074,2.647-1.989,3.779-.884,1.094-1.284,2.246-.607,3.089.746.93,2.3.588,3.536.869,2.97.675-.084,4.771.231,6.875.216,1.44,1.384,1.842,2.971,2.045,1.294.166,3.022.282,3.094,1.609.062,1.148-1.433,2.451-1.826,3.658a3.77,3.77,0,0,0,.288,3.182,3.477,3.477,0,0,0,2.33,1.525c1.471.313,3.7-.012,3.8,1.647.047.741-.469,1.4-.11,2.08a2.373,2.373,0,0,0,1.726,1.014,12.519,12.519,0,0,0,4.24-.075c1.726-.316,4.275-1.838,3.339-3.305a2.007,2.007,0,0,0-1.335-.767c-.414-.085-1.62.046-1.776-.234s.261-1.359.278-1.752a8.2,8.2,0,0,0-.5-3.166,9.656,9.656,0,0,0-2.229-3.531c-.408-.414-1.062-.718-1.146-1.321a2.945,2.945,0,0,1,.716-1.86,14.813,14.813,0,0,0,2.055-2.813c.582-1.564-.828-2.06-2.134-2.415-1.181-.321-2.735-.734-2.333-2.167.29-1.035,1.594-1.882,1.985-2.891.524-1.354-.754-1.407-1.671-1.891-1.189-.628-1.49-1.748-1.058-3.168.712-2.342,5-5.646,2.807-7.169-.558-.386-1.075-.516-1.411-1.1a12.654,12.654,0,0,0-.878-1.959c-.74-.895-2.269-1.045-3.068-1.875-1.639-1.7,1.9-4.724-1.33-5.443a3.845,3.845,0,0,1-1.888-.781c-.3-.276-.535-1.611-.87-1.7-1.482-.414-4.157,2.464-5,3.352-1.022,1.081-4.807,4.261-3.093,5.121",
    transform: "translate(-170.818 -38.965)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M361.05,111.359c-.881-1.63-4.731-3.256-2.175-5.148a21.5,21.5,0,0,1,4.417-2.305c2.236-.931,3.033-3.087,1.9-4.872a2.739,2.739,0,0,1-.483-1.262c-.091-1.647,2.364-2.043,3.777-2.634,1.365-.571,2.335-1.5,2.189-2.786-.161-1.416-1.715-2.032-2.654-3.086-2.259-2.537,2.628-4.834,3.476-7.185.58-1.609-.235-2.746-1.527-3.94-1.053-.974-2.516-2.167-1.869-3.571.56-1.214,2.576-1.619,3.569-2.611a4.821,4.821,0,0,0,1.449-3.437,4.46,4.46,0,0,0-1.24-3.009c-1.13-1.234-3.267-2.284-2.472-4.049.355-.788,1.162-1.14,1.21-2.061a3,3,0,0,0-.98-2.112,12.658,12.658,0,0,0-3.78-2.556c-1.693-.749-4.756-.774-4.715,1.31a2.531,2.531,0,0,0,.768,1.615c.32.344,1.455.959,1.441,1.342s-.958,1.229-1.184,1.621a10.761,10.761,0,0,0-1.25,3.555,13.378,13.378,0,0,0,.077,5c.139.677.553,1.4.3,2.065a3.158,3.158,0,0,1-1.627,1.46c-1.081.541-2.459.815-3.319,1.6-1.351,1.239-.372,2.624.59,3.8.87,1.062,2.019,2.45.9,3.669-.81.88-2.414.937-3.3,1.728-1.187,1.061-.088,1.909.462,2.974a3.183,3.183,0,0,1-.762,3.9c-1.881,1.956-7.437,2.673-6.314,5.6a4.91,4.91,0,0,1,.658,2,17.441,17.441,0,0,0-.274,2.551c.174,1.376,1.443,2.479,1.7,3.826.534,2.762-4.207,3.656-1.74,6.4a4.641,4.641,0,0,1,1.248,1.973c.113.467-.39,1.983-.145,2.286,1.086,1.344,4.987.059,6.2-.329,1.48-.472,6.522-1.377,5.47-3.323",
    transform: "translate(-184.901 -28.872)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M355.784,168.392s-.466,10.915-18.335,10.915-18.335-10.915-18.335-10.915Z",
    transform: "translate(-169.768 -89.585)",
    fill: "#f0f0f0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160717",
    "data-name": "Group 160717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160716",
    "data-name": "Group 160716",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M237.591,355.262c0,2.927-40.626,5.3-90.74,5.3s-90.74-2.372-90.74-5.3,40.626-5.3,90.74-5.3,90.74,2.373,90.74,5.3",
    transform: "translate(-29.851 -186.18)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160722",
    "data-name": "Group 160722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160721",
    "data-name": "Group 160721",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160720",
    "data-name": "Group 160720",
    transform: "translate(109.207 71.963)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160719",
    "data-name": "Group 160719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160718",
    "data-name": "Group 160718",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M292.963,290.29,263.156,235.2l-29.807,55.09Z",
    transform: "translate(-233.349 -197.09)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M292.963,153.768l-29.807,55.09-29.807-55.09Z",
    transform: "translate(-233.349 -153.768)",
    fill: "#407bff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M295.63,215.255l-4.361,8.061a1.249,1.249,0,0,1-2.2,0l-4.361-8.061a4.773,4.773,0,0,1,4.2-7.044h2.524a4.773,4.773,0,0,1,4.2,7.044",
    transform: "translate(-151.157 -110.768)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M280.712,323.09l13.53,5.568a1.249,1.249,0,0,1-.475,2.4h-27.06a1.249,1.249,0,0,1-.475-2.4l13.53-5.568a1.247,1.247,0,0,1,.95,0",
    transform: "translate(-141.223 -171.834)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M296.8,294.87a1.735,1.735,0,1,1-1.735-1.735,1.735,1.735,0,0,1,1.735,1.735",
    transform: "translate(-156.052 -155.948)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M296.917,257.08a.894.894,0,1,1-.894-.894.895.895,0,0,1,.894.894",
    transform: "translate(-157.008 -136.291)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M296.9,275.416a1.017,1.017,0,1,1-1.017-1.017,1.017,1.017,0,0,1,1.017,1.017",
    transform: "translate(-156.868 -145.98)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M289.9,347.112H230.586a2.715,2.715,0,0,0,0,5.43H289.9a2.715,2.715,0,1,0,0-5.43",
    transform: "translate(-121.227 -184.664)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M289.9,147.966H230.586a2.715,2.715,0,0,0,0,5.43H289.9a2.715,2.715,0,1,0,0-5.43",
    transform: "translate(-121.227 -78.718)",
    fill: "#407bff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M190.876,340.661l-3.3-1.071,2.052-7.781,3.3,1.071Z",
    transform: "translate(-99.79 -176.522)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160745",
    "data-name": "Group 160745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160744",
    "data-name": "Group 160744",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M178.669,347.45l3.707,1.2a.248.248,0,0,1,.172.3l-.772,2.992a.615.615,0,0,1-.768.4c-1.283-.441-1.875-.717-3.506-1.246-1-.325-4.309-1.179-5.694-1.629-1.355-.439-.9-1.806-.274-1.74a17.317,17.317,0,0,0,6.5-.265.978.978,0,0,1,.634-.018",
    transform: "translate(-90.932 -184.82)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160725",
    "data-name": "Group 160725",
    transform: "translate(88.78 155.288)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160724",
    "data-name": "Group 160724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160723",
    "data-name": "Group 160723",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M194.058,332.884l-3.3-1.071-1.056,4.011L193,336.9Z",
    transform: "translate(-189.701 -331.813)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M201.746,165.77s-5.921,27.4-7.31,37.253c-1.52,10.789-7.233,43.183-7.233,43.183l6.126,1.692s8.488-31.418,10.968-41.906c2.691-11.383,9.848-40.222,9.848-40.222Z",
    transform: "translate(-99.592 -88.19)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160728",
    "data-name": "Group 160728",
    transform: "translate(106.578 85.191)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160727",
    "data-name": "Group 160727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160726",
    "data-name": "Group 160726",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M230.628,183.406c-2.335,5.307-3.5,16.867-2.588,22.16,1.657-6.809,3.65-14.906,5.19-21.135-.52-1.806-1.381-3.8-2.6-1.025",
    transform: "translate(-227.731 -182.031)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M193.164,336.423l-6.561-1.807.127-2.672,7.387,2.554Z",
    transform: "translate(-99.273 -176.594)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M183.884,346.8a4.321,4.321,0,0,0,.918.168.081.081,0,0,0,.071-.129c-.082-.108-.809-1.049-1.263-1.022a.3.3,0,0,0-.25.16.444.444,0,0,0-.039.448.934.934,0,0,0,.563.375m.742-.013c-.629-.074-1.057-.234-1.162-.437a.289.289,0,0,1,.035-.292.144.144,0,0,1,.12-.081c.245-.015.7.442,1.007.81",
    transform: "translate(-97.503 -183.973)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M185.992,346.379a.081.081,0,0,0,.1-.046c.016-.039.4-.964.17-1.393a.4.4,0,0,0-.291-.213.311.311,0,0,0-.355.142,1.791,1.791,0,0,0,.341,1.486.079.079,0,0,0,.036.023m-.016-1.484a.241.241,0,0,1,.143.121,1.8,1.8,0,0,1-.124,1.118,1.633,1.633,0,0,1-.239-1.185c.024-.042.066-.087.183-.064l.037.009",
    transform: "translate(-98.713 -183.39)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M202.073,105.36c-.18.418-.326.736-.493,1.093s-.338.684-.512,1.022q-.524,1.012-1.09,2a38.816,38.816,0,0,1-2.529,3.826,28.432,28.432,0,0,1-3.114,3.555,17.907,17.907,0,0,1-4.06,3l-.117.063a2.386,2.386,0,0,1-.6.217,6.648,6.648,0,0,1-3.216-.129,9.313,9.313,0,0,1-2.454-1.139,16.083,16.083,0,0,1-3.39-3.072,27.93,27.93,0,0,1-2.463-3.423,30.14,30.14,0,0,1-1.935-3.67,1.516,1.516,0,0,1,2.56-1.571l.046.056c.773.941,1.61,1.935,2.453,2.843a32.278,32.278,0,0,0,2.613,2.566,12.966,12.966,0,0,0,2.686,1.872,3.933,3.933,0,0,0,1.154.381,1.262,1.262,0,0,0,.674-.058l-.714.28a14.176,14.176,0,0,0,2.626-2.293,28.762,28.762,0,0,0,2.362-3.007c.738-1.076,1.439-2.206,2.1-3.364.334-.578.657-1.164.964-1.755l.452-.888c.145-.283.307-.609.417-.842l.029-.061a3.042,3.042,0,0,1,5.545,2.5",
    transform: "translate(-93.619 -53.795)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160731",
    "data-name": "Group 160731",
    transform: "translate(100.037 54.419)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160730",
    "data-name": "Group 160730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160729",
    "data-name": "Group 160729",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M214.52,119.781c1.47-3.9,4.591-3.969,5.944-2.934-.1.183-.2.365-.3.548a39.741,39.741,0,0,1-2.41,3.7,30.586,30.586,0,0,1-2.934,3.454c-.337.332-.683.66-1.044.978a15,15,0,0,1,.749-5.747",
    transform: "translate(-213.754 -116.28)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M172.521,114.273l-3.041.108.761-3.248a15.726,15.726,0,0,1,3.1.451,1.229,1.229,0,0,1,.658,1.852l0,0a1.843,1.843,0,0,1-1.477.834",
    transform: "translate(-90.163 -59.123)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M176.389,111.375a2.954,2.954,0,0,0-1-.518,13.343,13.343,0,0,1-1.856,3.573H174.8a1.12,1.12,0,0,0,.859-.4l.888-1.063a1.119,1.119,0,0,0-.155-1.591",
    transform: "translate(-92.318 -58.976)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M164.517,112.272l.855-2.294,2.228.54-.76,3.248Z",
    transform: "translate(-87.523 -58.508)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M242.17,344.835H238.7l-.12-8.035h3.47Z",
    transform: "translate(-126.925 -179.178)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M230.249,353.11h3.9a.248.248,0,0,1,.257.237l.189,3.084a.614.614,0,0,1-.607.617c-1.357-.023-2.005-.1-3.72-.1-1.054,0-4.58.11-6.036.11-1.424,0-1.415-1.44-.8-1.571,2.767-.585,5.239-1.391,6.219-2.16a.977.977,0,0,1,.6-.213",
    transform: "translate(-118.655 -187.855)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160734",
    "data-name": "Group 160734",
    transform: "translate(111.655 157.625)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160733",
    "data-name": "Group 160733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160732",
    "data-name": "Group 160732",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M242.05,336.8h-3.471l.064,4.142h3.471Z",
    transform: "translate(-238.579 -336.805)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M231.715,165.77s-1.325,30.144-.762,40.078c.616,10.878,1.91,43.108,1.91,43.108h6.355s1.6-31.352,1.985-42.122c.416-11.689,2.3-41.064,2.3-41.064Z",
    transform: "translate(-122.793 -88.19)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M240.918,340.615h-6.867l-.523-2.553,7.579.377Z",
    transform: "translate(-124.237 -179.849)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M234.946,353.4a4.334,4.334,0,0,0,.925-.124.08.08,0,0,0,.061-.064.081.081,0,0,0-.033-.081c-.111-.077-1.093-.748-1.517-.582a.3.3,0,0,0-.188.229.443.443,0,0,0,.1.439.936.936,0,0,0,.651.183m.7-.242c-.621.124-1.078.1-1.24-.057a.29.29,0,0,1-.057-.289.143.143,0,0,1,.089-.114c.228-.089.805.2,1.208.459",
    transform: "translate(-124.582 -187.544)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M236.81,352.359a.08.08,0,0,0,.037-.009.081.081,0,0,0,.044-.065c0-.043.081-1.04-.269-1.378a.4.4,0,0,0-.343-.113.31.31,0,0,0-.293.245c-.08.379.438,1.1.783,1.309a.081.081,0,0,0,.041.011m-.474-1.406a.239.239,0,0,1,.174.071,1.8,1.8,0,0,1,.228,1.1c-.3-.255-.646-.8-.593-1.053.01-.047.036-.1.154-.117a.253.253,0,0,1,.037,0",
    transform: "translate(-125.54 -186.621)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M237.6,102.475A2.207,2.207,0,0,0,235.75,99.9l-.041-.006c-1.119-.164-2.523-.332-3.9-.4a69.312,69.312,0,0,0-7.885,0c-1.213.113-2.4.314-3.342.5l-.036.007a3.324,3.324,0,0,0-2.524,2.313c-1.132,3.816-2.481,11.6-.716,28.138h18.556c.131-1.657-.238-7.048.033-13.914a109.442,109.442,0,0,1,1.707-14.065",
    transform: "translate(-115.154 -52.873)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160737",
    "data-name": "Group 160737",
    transform: "translate(119.056 50.218)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160736",
    "data-name": "Group 160736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160735",
    "data-name": "Group 160735",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M257.607,107.709c-.385,2.219-.86,5.235-1.187,8.409a21.577,21.577,0,0,1-2-6.164c-.308-2.843,2.113-3.042,3.188-2.245",
    transform: "translate(-254.393 -107.304)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160740",
    "data-name": "Group 160740",
    transform: "translate(108.581 46.512)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160739",
    "data-name": "Group 160739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160738",
    "data-name": "Group 160738",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M234.468,105.3a.176.176,0,0,1-.081-.331l5.785-3a.176.176,0,0,1,.161.312l-5.784,3a.18.18,0,0,1-.081.02",
    transform: "translate(-233.224 -100.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M236.528,105.708a.175.175,0,0,1-.124-.051l-3.169-3.153a.175.175,0,0,1,.248-.249l3.169,3.153a.176.176,0,0,1-.124.3",
    transform: "translate(-232.634 -100.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M240.084,99.5a69.128,69.128,0,0,0-7.881,0l-.131.014a1.861,1.861,0,0,0,.2,1.437,3.246,3.246,0,0,0,2.747,1.17q.267.014.519.014c3.767,0,5.19-2.274,5.251-2.373l.131-.211c-.281-.019-.557-.037-.838-.051",
    transform: "translate(-232.01 -99.384)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M233.107,89.546a2.9,2.9,0,0,0,2.541-3.519,9.324,9.324,0,0,0-.183-1.161l2.874-2.387,2.111-1.75c-.585,2.541-1.245,7.17.473,8.864,0,0-1.422,2.344-5.346,2.132-3.315-.179-2.469-2.179-2.469-2.179",
    transform: "translate(-123.962 -42.948)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160743",
    "data-name": "Group 160743",
    transform: "translate(111.504 39.532)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160742",
    "data-name": "Group 160742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160741",
    "data-name": "Group 160741",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M238.257,86.856a9.408,9.408,0,0,1,.182,1.161,3.659,3.659,0,0,0,2.654-2.452,4.987,4.987,0,0,0,.037-1.1Z",
    transform: "translate(-238.257 -84.469)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M233,63.548c-1.56.916-1.311,3.277-1.735,4.953.994.1,2.557-1.666,2.557-1.666l.934-2.682Z",
    transform: "translate(-123.033 -33.808)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M240.773,66.878c-1,3.305-1.411,5.285-3.519,6.663a4.488,4.488,0,0,1-6.984-3.792c-.014-3.152,1.619-8.028,5.232-8.7a4.542,4.542,0,0,1,5.272,5.831",
    transform: "translate(-122.503 -32.43)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M238.943,65.453c2.338-2.715-.585-4.054,1.806-5.939-2.691.127-7.122-.065-7.912-1.911s1.643-4.342,3.668-4.576c2.356-.272,1.833,2.626,1.833,2.626s8.957-.559,6.113,3.25c2.155-.13,1.562,3.354-2.185,6.292a13.419,13.419,0,0,1-3.324.258",
    transform: "translate(-123.788 -28.201)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M256.682,63.473s1.844-.546,1.78-2.009c.667.458.735,1.853-1.78,2.009",
    transform: "translate(-136.555 -32.699)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M250.266,78.425a3.7,3.7,0,0,1-2.127,1.3c-1.062.193-1.312-.79-.782-1.748.477-.862,1.605-2,2.558-1.761s1.031,1.376.351,2.212",
    transform: "translate(-131.451 -40.528)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M240.556,72.784c-.064.272-.262.464-.441.429s-.273-.286-.208-.558.262-.465.441-.429.272.286.208.558",
    transform: "translate(-127.62 -38.422)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M233.929,71.46c-.064.272-.262.464-.441.429s-.272-.286-.208-.558.262-.465.441-.429.272.286.208.558",
    transform: "translate(-124.094 -37.718)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M234.613,72.811a10.464,10.464,0,0,1-1.861,2.069,1.591,1.591,0,0,0,1.253.506Z",
    transform: "translate(-123.824 -38.735)",
    fill: "#ff5652"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M237.013,79.541a2.409,2.409,0,0,0,1.8-.58.082.082,0,0,0-.115-.117,2.3,2.3,0,0,1-1.974.491.082.082,0,0,0-.032.161,2.663,2.663,0,0,0,.323.045",
    transform: "translate(-125.884 -41.932)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M242.533,70.491a.164.164,0,0,0,.162-.232,1.578,1.578,0,0,0-1.16-.926.161.161,0,0,0-.183.142.164.164,0,0,0,.142.184,1.253,1.253,0,0,1,.9.737.165.165,0,0,0,.137.1",
    transform: "translate(-128.398 -36.883)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M232.918,67.357a.165.165,0,0,0,.151-.027,1.376,1.376,0,0,1,1.181-.28.164.164,0,0,0,.1-.313h0a1.7,1.7,0,0,0-1.482.334.164.164,0,0,0-.029.23.162.162,0,0,0,.08.056",
    transform: "translate(-123.852 -35.477)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M255.788,101.725l.391.532.351.5c.231.33.443.664.661,1,.429.665.828,1.345,1.22,2.027a45.516,45.516,0,0,1,2.114,4.213c.327.714.611,1.451.91,2.179.263.746.55,1.478.781,2.237a41.484,41.484,0,0,1,1.217,4.6l.038.176a2.446,2.446,0,0,1-.336,1.844,13.284,13.284,0,0,1-2.129,2.524,10.985,10.985,0,0,1-2.8,1.885,10.085,10.085,0,0,1-3.211.89,9.853,9.853,0,0,1-1.636.03c-.272-.021-.542-.052-.814-.1-.136-.022-.272-.05-.412-.08l-.471-.114a.216.216,0,0,1-.159-.261l.647-2.713c.005-.021.124-.029.2-.046l.258-.052c.175-.036.352-.078.526-.127a7.91,7.91,0,0,0,1.018-.351,7.354,7.354,0,0,0,1.772-1.046,8.935,8.935,0,0,0,2.464-3.2l-.3,2.021c-.4-1.323-.826-2.638-1.345-3.931s-1.072-2.57-1.687-3.825-1.268-2.494-1.974-3.7c-.348-.606-.714-1.2-1.077-1.79l-.557-.868-.278-.423-.255-.375-.094-.138a3.04,3.04,0,0,1,4.963-3.51",
    transform: "translate(-133.159 -53.459)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M247.635,152.333l-1.01,1.65,4.37-.176s1.144-2.939-.42-3.4l-.6.168a3.992,3.992,0,0,0-2.336,1.762",
    transform: "translate(-131.204 -80.015)",
    fill: "#ff8b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M251.714,149.383a2.968,2.968,0,0,0-.8.8,13.318,13.318,0,0,1,2.847,2.847l.382-1.208a1.119,1.119,0,0,0-.124-.941l-.746-1.166a1.118,1.118,0,0,0-1.563-.332",
    transform: "translate(-133.488 -79.372)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M247.01,160.386l3.6-.32.384-2.392-4.37.176Z",
    transform: "translate(-131.204 -83.882)",
    fill: "#ff8b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160750",
    "data-name": "Group 160750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160749",
    "data-name": "Group 160749",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M157.07,41.8l-.239-.4a16.2,16.2,0,0,1,2.142-1.064l.176.433A15.688,15.688,0,0,0,157.07,41.8",
    transform: "translate(-83.434 -21.456)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M142.239,52.22l-.44-.159a16.26,16.26,0,0,1,5.737-7.631l.276.378a15.786,15.786,0,0,0-5.572,7.412",
    transform: "translate(-75.437 -23.637)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M172.513,56.143a14.4,14.4,0,1,1-14.4-14.4,14.4,14.4,0,0,1,14.4,14.4",
    transform: "translate(-76.451 -22.205)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160748",
    "data-name": "Group 160748",
    transform: "translate(69.622 21.902)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160747",
    "data-name": "Group 160747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160746",
    "data-name": "Group 160746",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M172.834,58.834a12.03,12.03,0,1,1-3.144-8.113c.006,0,.016.006.022.022a12,12,0,0,1,3.122,8.091",
    transform: "translate(-148.765 -46.799)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M173.6,59.6a12.033,12.033,0,0,1-20.2,8.843,12.032,12.032,0,0,1,17.053-16.956c.006,0,.016.006.022.022A12,12,0,0,1,173.6,59.6",
    transform: "translate(-79.911 -25.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M163.809,73.242a1.091,1.091,0,0,0,.773-.32l9.141-9.141a1.093,1.093,0,1,0-1.546-1.546L163.809,70.6l-4.834-4.833a1.093,1.093,0,0,0-1.546,1.546l5.607,5.607a1.09,1.09,0,0,0,.773.32",
    transform: "translate(-83.582 -32.938)",
    fill: "#407bff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatValidationPendingIcon);
export default __webpack_public_path__ + "static/media/live-chat-validation-pending-icon.f27d263c40d206fc435c6324b668e868.svg";
export { ForwardRef as ReactComponent };